<template>
  <div class="container">
    <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
      <i class="el-icon-back"></i>
      返回
    </div>
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="search.kname" @change="Search" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.code" @change="Search" placeholder="品类编号"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="AddCategory">增加</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <el-table-column label="名称">
        <template v-slot="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图标">
        <template v-slot="scope">
          <span>{{ scope.row.icon }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="EditCategory(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="DeleteCatogry(scope.row)">删除</el-button>
          <i style="font-weight: 700" class="el-icon-top sort" @click="CategorySort(scope.row,2)"></i>
          <i style="font-weight: 700" class="el-icon-bottom sort" @click="CategorySort(scope.row,1)"></i>
          <!-- <el-button type="info" size="small" @click="panelManage(scope.row.id)">面板管理</el-button>
          <el-button type="info" size="small" @click="planManage(scope.row.id)">方案管理</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title+'品类'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="品类名称" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon" label-width="100px">
          <el-input v-model="form.icon" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="Validate(Addconfirm)">{{edit?'修改':'新增'}}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        page: 1,
        limit: 10,
        type_code: '',
        kname: '',
        code: '',
      },
      list: [],
      total: 0,
      title: '',
      dialogFormVisible: false,
      form: {
        code: '',
        type_code: '',
        icon: '',
        name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        icon: [{ required: true, message: '请输入图标', trigger: 'blur' }],
      },
      edit: false,
      checkList: ['选中且禁用','复选框 A']
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    Search () {
      this.api.CategoryList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    AddCategory () {
      this.form = {}
      this.title = '新增'
      this.edit = false
      this.dialogFormVisible = true
    },
    EditCategory(item) {
      this.form = {}
      this.title = '编辑'
      this.edit = true
      this.api.CategoryDetail({
        code: item.code
      }).then(res => {
        if (res.data.code == 200) {
          this.form = res.data.data
          this.dialogFormVisible = true
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    DeleteCatogry(item) {
      this.$confirm('是否删除该品类?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.CategoryDelete({code:item.code}).then(res => {
          if (res.data.code == 200) {
            this.$message({type: 'success',message: '删除成功!'});
            this.Search()
            return
          }
          this.$message.error('删除失败' + res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    panelManage() {

    },
    planManage() {

    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    Addconfirm () {
      this.form.type_code = this.$route.params.code
      this.api.CategoryUpdate(this.form).then(res => {
        if (res.data.code == 200) {
          this.$message.success(this.title+'成功')
          this.Search()
          this.dialogFormVisible = false
          return
        }
        this.$message.error(this.title+'失败' + res.data.msg)
      })
    },
    CategorySort (item, action) {
      this.api.CategoryOrder({
        code: item.code,
        action: action
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success('更改排序成功')
          this.Search()
          return
        }
        this.$message.error('更改排序失败' + res.data.msg)
      })
    },
    goback (){
      this.$router.push('/iotmanage/categorytype')
    }
  },
  filters: {},
  mounted () {
    this.search.type_code = this.$route.params.code
    this.Search()
  },
  created () { }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.sort {
  font-size: 16px;
  margin: 0 5px;
  cursor: pointer;
  font-weight: 700px!important;
}
</style>
